import React, { Fragment, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { useDispatch } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import cn from 'classnames';
import NotificationSystem from 'react-notification-system';

import { signIn } from 'actions/auth';
import { getFeatures } from 'actions/application';
import Header from 'components/Header';
import FormGroup from 'components/Form/FormGroup';
import FormGroupLabel from 'components/FormGroupLabel';
import { Grid, Column } from 'components/Layout';
import Input from 'components/Form/Input';
import Validator from 'components/Validator/Validator';
import { Button, ButtonLink } from 'components/Button';

import schema from './loginSchema';
import style from './style.scss';

const Login = (props) => {
  const dispatch = useDispatch();
  const [redirectToReferrer, setRedirectToReferrer] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const notification = useRef(null);
  const { from } = props.location.state || { from: { pathname: '/' } };
  const { validator: { values, errors } } = props;

  const handleInputChange = (event) => {
    const { validator: { onChangeHandler } } = props;
    const value = event.target.value.trim();
    if (event.target.name === 'username') {
      onChangeHandler(event.target.name, value.toLowerCase());
    } else {
      onChangeHandler(event.target.name, value);
    }
  };

  const handleSubmitFrom = (data, e) => {
    e.preventDefault();
    const { validator: { validate } } = props;

    if (validate(schema).isValid) {
      const formData = data;
      setIsLoading(true);
      dispatch(signIn({
        data: formData,
        success: () => {
          dispatch(getFeatures({
            url: `/merchants/${localStorage.getItem('merchantId')}/features`,
            success: (featuresRes) => {
              localStorage.setItem('features', JSON.stringify(featuresRes));
              setRedirectToReferrer(true);
              setIsLoading(false);
            },
            fail: (err) => {
              notification.current
              && notification.current.addNotification({
                message: err.message || 'Fetching features failed',
                level: 'error',
                position: 'tc',
              });
              setIsLoading(false);
            },
          }));
        },
        fail: (res) => {
          if (res.code === 'UserNotFoundException') {
            notification.current
            && notification.current.addNotification({
              message: res.message,
              level: 'error',
              position: 'tc',
            });
            setIsLoading(false);
          } else if (res.code === 'NotAuthorizedException') {
            notification.current
            && notification.current.addNotification({
              message: res.message,
              level: 'error',
              position: 'tc',
            });
            setIsLoading(false);
          } else if (res.code === 'PasswordResetRequiredException') {
            localStorage.setItem('reset-user', data.username);
            props.history.push('/forgot');
          } else if (res.code === 'InvalidMerchant') {
            notification.current
            && notification.current.addNotification({
              message: res.message,
              level: 'error',
              position: 'tc',
            });
            setIsLoading(false);
          } else {
            setError(res);
            setIsLoading(false);
          }
        },
      }));
    }
  };

  const forgotPassworrd = () => {
    props.history.push('/forgot');
  };

  return redirectToReferrer ? <Redirect to={from} /> : (
    <Fragment>
      <NotificationSystem ref={notification} />
      <Header />
      <section className={cn('grid-container fluid borrowers-apply section', style.loginContainer)}>
        <div className={cn('grid-container', style.innerLogin)}>
          <Grid className="grid-margin-x max-limited">
            <Column className="small-12 large-12 main-column">
              <FormGroup className="form-group">
                <form onSubmit={handleSubmitFrom}>
                  <Grid className="grid-margin-x">
                    <Column className="small-12 medium-10 medium-offset-1">
                      <FormGroupLabel value="Login" />
                      <Grid className="grid-margin-x">
                        <Column className="small-12 medium-12">
                          <Input
                            name="username"
                            label="Username"
                            value={values.username}
                            onChange={handleInputChange}
                            hasError={!!errors.username}
                            hasValue
                            placeHolder="username"
                            isBadgeVisible={false}
                            isRequired
                          />
                        </Column>
                        <Column className="small-12 medium-12">
                          <Input
                            name="password"
                            type="password"
                            label="Password"
                            value={values.password}
                            onChange={handleInputChange}
                            hasError={!!errors.password}
                            hasValue
                            placeHolder="password"
                            isBadgeVisible={false}
                            isRequired
                          />
                        </Column>
                        <Column className="small-12 medium-12">
                          <Button
                            className={cn('button small green w-100', style.button)}
                            onClick={handleSubmitFrom.bind(null, values)}
                            isLoading={isLoading}
                          >
                            Login
                          </Button>
                          <Column className={cn('small-12 medium-12', style.forgotPassword)}>
                            <ButtonLink onClick={forgotPassworrd}>Forgot password?</ButtonLink>
                          </Column>
                        </Column>
                      </Grid>
                    </Column>
                  </Grid>
                </form>
              </FormGroup>
            </Column>
          </Grid>
        </div>
      </section>
      {error && (<label className="error">{error}</label>)}
    </Fragment>
  );
};

Login.propTypes = {
  validator: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default compose(
  withRouter,
  Validator(schema)
)(Login);



// WEBPACK FOOTER //
// ./src/containers/pages/Auth/Login.js